import { get, isEmpty } from 'lodash';
import useSWR from 'swr';

import { fetcher } from 'util/Api';

function useTenant(options) {
  const { data, error, mutate } = useSWR(`/api/v1/tenants`, fetcher, options);
  const tenant = get(data, 'data', {});

  return {
    tenant,
    loading: !error && isEmpty(tenant),
    error,
    mutate,
  };
}

export default useTenant;
